import Sidebar from "../components/Sidebar";

const statCards = [
  {
    title: "Active Jobs",
    value: "12",
    change: "+3 this week",
    color: "orange",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    title: "Completed Jobs",
    value: "87",
    change: "+5 this month",
    color: "green",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: "Pending Quotes",
    value: "4",
    change: "2 new today",
    color: "blue",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: "Revenue",
    value: "$24,500",
    change: "This month",
    color: "purple",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
];

const colorMap = {
  orange: { bg: "bg-orange-50", text: "text-orange-500" },
  green: { bg: "bg-green-50", text: "text-green-500" },
  blue: { bg: "bg-blue-50", text: "text-blue-500" },
  purple: { bg: "bg-purple-50", text: "text-purple-500" },
};

const recentJobs = [
  { id: "TMP-0041", client: "BuildCorp Pty Ltd", type: "TMP", status: "In Progress", date: "Apr 6, 2026" },
  { id: "TGS-0039", client: "Metro Roads Inc", type: "TGS", status: "Completed", date: "Apr 4, 2026" },
  { id: "TMP-0038", client: "Sunrise Developments", type: "TMP", status: "In Review", date: "Apr 3, 2026" },
  { id: "TC-0037", client: "CityWorks Council", type: "TC", status: "Completed", date: "Apr 1, 2026" },
  { id: "TGS-0036", client: "Apex Constructions", type: "TGS", status: "In Progress", date: "Mar 30, 2026" },
];

const statusColors = {
  "In Progress": "bg-orange-100 text-orange-600",
  Completed: "bg-green-100 text-green-600",
  "In Review": "bg-blue-100 text-blue-600",
};

export default function Dashboard() {
  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 bg-gray-50 min-h-[calc(100vh-4rem)]">
        <div className="p-6 md:p-8 max-w-6xl">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-black">
              Welcome back
            </h1>
            <p className="text-gray-500 mt-1">
              Here's what's happening with your projects.
            </p>
          </div>

          {/* Stat cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
            {statCards.map((card) => {
              const colors = colorMap[card.color];
              return (
                <div
                  key={card.title}
                  className="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-lg hover:shadow-gray-200/50 transition-all duration-300"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div
                      className={`w-10 h-10 ${colors.bg} ${colors.text} rounded-lg flex items-center justify-center`}
                    >
                      {card.icon}
                    </div>
                  </div>
                  <div className="text-2xl font-bold text-black">
                    {card.value}
                  </div>
                  <div className="text-sm text-gray-500 mt-0.5">
                    {card.title}
                  </div>
                  <div className="text-xs text-gray-400 mt-2">{card.change}</div>
                </div>
              );
            })}
          </div>

          {/* Recent jobs table */}
          <div className="bg-white rounded-xl border border-gray-200">
            <div className="px-6 py-4 border-b border-gray-100">
              <h2 className="text-lg font-semibold text-black">Recent Jobs</h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    <th className="px-6 py-3">Job ID</th>
                    <th className="px-6 py-3">Client</th>
                    <th className="px-6 py-3">Type</th>
                    <th className="px-6 py-3">Status</th>
                    <th className="px-6 py-3">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {recentJobs.map((job) => (
                    <tr
                      key={job.id}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-6 py-4 text-sm font-medium text-black">
                        {job.id}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600">
                        {job.client}
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-xs font-medium bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full">
                          {job.type}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`text-xs font-medium px-2.5 py-1 rounded-full ${statusColors[job.status]}`}
                        >
                          {job.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {job.date}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
